import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RoleGuard } from '../../core/guards/role.guard';


const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {
      controllerName: '/dashboard'
    },
    canActivate: [RoleGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
